import { Response } from "@/types"

import { FetchMethod, useCodeerApi } from "../useCodeerApi"

export interface PaymentGatewayAccountResponse {
  id: string
  workspace_id: string
  provider: string
  name: string
  merchant_id: string
  is_active: boolean
  has_hash_key: boolean
  has_hash_iv: boolean
  hash_key_preview?: string | null
  hash_iv_preview?: string | null
  created_at: string
  updated_at: string
}

export interface UpsertPaymentGatewayAccountRequest {
  merchant_id: string
  hash_key?: string
  hash_iv?: string
  name?: string
  is_active?: boolean
}

export interface PaymentRequestStatusResponse {
  payment_request_id: string
  checkout_url: string
  merchant_order_no: string
  amount_twd: number
  currency: string
  status: string
  payment_method?: string | null
  trade_no?: string | null
  paid_at?: string | null
  updated_at: string
}

export interface WorkspacePaymentRequestListItemResponse {
  payment_request_id: string
  merchant_order_no: string
  item_desc?: string | null
  amount_twd: number
  currency: string
  status: string
  agent_id?: string | null
  agent_name?: string | null
  external_user_id?: string | null
  paid_at?: string | null
  created_at: string
  updated_at: string
}

export interface WorkspacePaymentRequestDetailResponse extends WorkspacePaymentRequestListItemResponse {
  payment_method?: string | null
  trade_no?: string | null
  admin_note: string
}

export interface WorkspacePaymentRequestListFilters {
  limit?: number
  offset?: number
  order_by?: string
  agent_id?: string
  created_from?: string
  created_to?: string
  query?: string
  include_guest_requests?: boolean
}

export interface UpdateWorkspacePaymentRequestRequest {
  admin_note: string
}

export const useGetWorkspacePaymentGatewayApi = (workspaceId: string) => {
  return useCodeerApi<Response<PaymentGatewayAccountResponse>>(
    `/payments/workspaces/${workspaceId}/gateway-account`,
    FetchMethod.Get
  )
}

export const useUpsertWorkspacePaymentGatewayApi = (workspaceId: string) => {
  return useCodeerApi<
    Response<PaymentGatewayAccountResponse>,
    UpsertPaymentGatewayAccountRequest
  >(`/payments/workspaces/${workspaceId}/gateway-account`, FetchMethod.Put)
}

export const useListWorkspacePaymentRequestsApi = (workspaceId: string) => {
  return useCodeerApi<Response<WorkspacePaymentRequestListItemResponse[]>>(
    `/payments/workspaces/${workspaceId}/requests`,
    FetchMethod.Get
  )
}

export const useGetWorkspacePaymentRequestApi = (
  workspaceId: string,
  paymentRequestId: string
) => {
  return useCodeerApi<Response<WorkspacePaymentRequestDetailResponse>>(
    `/payments/workspaces/${workspaceId}/requests/${paymentRequestId}`,
    FetchMethod.Get
  )
}

export const useUpdateWorkspacePaymentRequestApi = (
  workspaceId: string,
  paymentRequestId: string
) => {
  return useCodeerApi<
    Response<WorkspacePaymentRequestDetailResponse>,
    UpdateWorkspacePaymentRequestRequest
  >(
    `/payments/workspaces/${workspaceId}/requests/${paymentRequestId}`,
    FetchMethod.Patch
  )
}

export const useGetPaymentRequestStatusApi = (paymentRequestId: string) => {
  return useCodeerApi<Response<PaymentRequestStatusResponse>>(
    `/payments/requests/${paymentRequestId}`,
    FetchMethod.Get
  )
}

export const useCancelPaymentRequestApi = (paymentRequestId: string) => {
  return useCodeerApi<Response<PaymentRequestStatusResponse>>(
    `/payments/requests/${paymentRequestId}/cancel`,
    FetchMethod.Post
  )
}
